// -*-mode: rjsx -*-

// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"
import clsx from "clsx"

// ROUTER
// eslint-disable-next-line
import { Link, Redirect } from "react-router-dom"

// MUI
// eslint-disable-next-line
import { lighten, withStyles } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
import Typography from "@material-ui/core/Typography"
// eslint-disable-next-line
import Paper from "@material-ui/core/Paper"
// eslint-disable-next-line
import Favorite from "@material-ui/icons/Favorite"
// eslint-disable-next-line
import FavoriteBorder from "@material-ui/icons/FavoriteBorder"
// eslint-disable-next-line
import UncheckedCircle from "@material-ui/icons/RadioButtonUnchecked"
// eslint-disable-next-line
import CheckedCircle from "@material-ui/icons/CheckCircleOutline"
// eslint-disable-next-line
import Card from "@material-ui/core/Card"
// eslint-disable-next-line
import Checkbox from "@material-ui/core/Checkbox"
import Fab from "@material-ui/core/Fab"
import DownIcon from "@material-ui/icons/KeyboardArrowDown"
import UpIcon from "@material-ui/icons/KeyboardArrowUp"
// eslint-disable-next-line
import HelpIcon from "@material-ui/icons/HelpOutline"
import grey from "@material-ui/core/colors/grey"
import Grid from '@material-ui/core/Grid';
import FormControlLabel from "@material-ui/core/FormControlLabel"
import GreenCheckbox from "./GreenCheckbox"

// eslint-disable-next-line
import DashBarChart from "../Dash/A/DashBarChart.js"
import DashTable from "../Dash/A/Dash3ColTable.js"
import DashTrend from "../Dash/A/DashTrend.js"
import DashInfo from "../Dash/A/DashInfo.js"

// UTILS
// eslint-disable-next-line
import * as _ from "lodash"
// eslint-disable-next-line
import * as moment from "moment"

// FLASH
// eslint-disable-next-line
import FlashTopBar from "../Flash/FlashTopBar.js"
import FlashHeader from "../Flash/FlashHeader.js"
// eslint-disable-next-line
import FlashSubHeader from "../Flash/FlashSubHeader.js"

// LogRocket
// import LogRocket from 'logrocket'

// BL
import {
    getIssueTrends,
    getStatementTrends,
    calcStatementTableDatasetTail,
    enrichTrend,
    addGraphTimestamps,
    getStatementTrendsV2,
    calcStatementTableDatasetTailV2,
    genTimeRange,
    getIssueTrendsV2
} from "../../bl/A/bl"

import {
    groupBy,
    groupSort,
    jsonSetPathValue
} from "../Utils.js"



// LOGGING SETUP
import appConfig from "./../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<SDash>")
//LogRocket.init('sbqpcc/flashdev')

const VARIATION = "A"


const styles = theme => ({
    
    //
    // GLOBAL STYLES START
    //
    separatorDiv: {
        ...theme.css.separatorDiv,
        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            width: theme.css.separatorDiv.desktop.width,
            height: theme.css.separatorDiv.desktop.height,
            marginTop: theme.css.separatorDiv.desktop.marginTop, // separate sections
            marginLeft: theme.css.separatorDiv.desktop.marginLeft,
            // borderRadius: theme.css.separatorDiv.desktop.borderRadius,
            // boxShadow: theme.css.separatorDiv.desktop.boxShadow,
            // borderTopLeftRadius: 6,
            // borderTopRightRadius: 6,
        },
    },

    checkedCircle: {
        ...theme.css.checkedCircle
    },

    uncheckedCircle: {
        ...theme.css.uncheckedCircle
    },
    //
    // GLOBAL STYLES END
    //
    
    continueButton: {
        margin: 20,
        padding: 8,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        "&:hover": {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.light,
        },
    },

    contactList: {
        margin: 0,
        marginTop: 0,
        // tab from the left
        padding: "0px",
        // inside the container
        width: "100%",
    },

    contactItem: {
        // gap between cards (individual items)
        margin: 0,
        // cursor: "pointer",
        borderRadius: 0, // default 4
    },


    //
    // new stuff
    //
    mainDiv: {
        // mobile
        marginTop: 0,
        marginBottom: 0,
        marginLeft: "auto",
        marginRight: "auto",
        padding: 0,
        paddingTop: 90,


        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            paddingTop: 100,
	    // maxWidth: 1500, // this is different for dashboard
            // TODO: calculate this below
            maxWidth: 1250 // it's different for sahsboard vs. webapp
        },


        //
        // desktop - if more than 600
        //
        [theme.breakpoints.down("md")]: {
            paddingLeft: 0,
            paddingRight: 0
        },

        color: theme.palette.test.mainFG,
        background: theme.palette.test.mainBG,
    },

    

    mainDivFilter: {
        // mobile
        marginTop: 0,
        marginBottom: 0,
        marginLeft: "auto",
        marginRight: "auto",
        padding: 0,
        paddingTop: 90,

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            paddingTop: 100,
	    // maxWidth: 1500, // this is different for dashboard
            // TODO: calculate this below
            maxWidth: 1500 // it's different for sahsboard vs. webapp
        },

        color: theme.palette.test.mainFG,
        background: theme.palette.test.mainBG,
    },
    

    paperRoot: {
        // mobile
        margin: 0,
        maxWidth: "100%",
        padding: 10,
        paddingTop: 10,
        paddingBottom: 10,
        // maxHeight: 56,
        overflow: "hidden",
        cursor: "pointer",
        userSelect: "none",
        backgroundColor: "#FFFFFF",

        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            marginBottom: 0,
            borderBottom: "1px solid",
            borderBottomColor: grey[200],
	    borderRadius: 0,
        },

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            marginTop: 15,
            borderRadius: 6,
        },
        
    },

    optionsPaperRoot: {
        // mobile
        margin: 0,
        maxWidth: "100%",
        // padding: 10,
        // paddingTop: 10,
        // paddingBottom: 10,
        // maxHeight: 56,
        overflow: "hidden",
        cursor: "pointer",
        userSelect: "none",
        backgroundColor: "#FFFFFF",

        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            marginBottom: 0,
            borderBottom: "1px solid",
            borderBottomColor: grey[200],
	    borderRadius: 0,
        },

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            // marginTop: 15,
            // borderRadius: 6,
            borderRadius: 0,
        },
        
    },

    // SCROLL FAB
    fab: {
        position: "fixed",
        // bottom: theme.spacing(12),
        bottom: theme.spacing(2),
        // right: theme.spacing(1),
        // left: "45%", // middle
        left: "83%", // middle
        zIndex: 500,
        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            left: "75%",
        },
    },
    
    fabGreen: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.custom.scrollDark,
        '&:hover': {
            backgroundColor: theme.palette.custom.scrollLight,
        },
    },

    gridContainer: {
        // backgroundColor: "yellow",
        "&.MuiGrid-spacing-xs-2": {
            // backgroundColor: "red",
            "& .MuiGrid-item": { // this one *HAS* to have a space
                // no padding for items in mobile mode
                // backgroundColor: "blue",
                [theme.breakpoints.down("sm")]: {
                    backgroundColor: "green",
                    padding: 0
                },
            }
        }
    },

    
})

const parseUrl = (location) => {

    const search = location.search; // could be '?foo=bar'
    const params = new URLSearchParams(search);

    let geo
    try {
        geo = JSON.parse(params.get('geo'))
        if(!geo) throw new Error("Error no geo in url")
        log.trace("parseUrl(): geo =", geo)
    } catch (error) {
        log.trace("parseUrl(): ERROR: error = ", error)
        log.trace("parseUrl(): ERROR: could not decode url param geo in search.params =", search)
    }


    let issue
    try {
        issue = JSON.parse(params.get('issue'))
        if(!issue) throw new Error("Error no issue in url")
        log.trace("parseUrl(): issue =", issue)
    } catch (error) {
        log.trace("parseUrl(): ERROR: error = ", error)
        log.trace("parseUrl(): ERROR: could not decode url param issue in search.params =", search)
    }
    
    return  {
        geo: geo,
        issue: issue
    }
}

class IDashState extends Component {
    constructor(props) {
        super(props)
        log.trace("constructor()")

        //let localGL = JSON.parse(localStorage.getItem("gl"))
        //let localDash = JSON.parse(localStorage.getItem("localDash"))
        //log.trace("constructor(): localGL =", localGL)
        //log.trace("constructor(): localDash =", localDash)

//        let oldFilters = getIssuesFilters({
//            level: "Federal",
//            geoState: "All-States",
//            geoZip: "All-Zips"
//        })

//        if(localGL && localGL.sdash && localGL.sdash.currentFilters) {
//            oldFilters = localGL.sdash.currentFilters
//        }

        // we're alwasy in state view here
        //        const geoCodes = [localDash.stateView.d.properties.stateFP]
        //        log.trace("constructor(): localDash: geoCodes =", geoCodes)


        // new for the sdash
        //log.trace("constructor(): localDash.issueDetailView =", localDash.issueDetailView)
        //const issue = localDash.issueDetailView.issue
        //const geo = localDash.issueDetailView.geo

        const { location } = this.props
        
        let { geo: parsedGeo, issue: parsedIssue } = parseUrl(location)
        log.debug("constructor(): SSDDATA: parsedGeo = ", parsedGeo)


        let geo
        if(!parsedGeo || parsedGeo === null) {
            log.trace("constructor(): ONE parsedGeo = ", parsedGeo)
            geo = { level: "NATIONAL" }
        } else {
            log.trace("constructor(): TWO parsedGeo = ", parsedGeo)
            geo = parsedGeo
        }


        let issue
        if(!parsedIssue || parsedIssue === null) {
            log.trace("constructor(): ONE parsedIssue = ", parsedIssue)
            issue = { uuid: "default-issue-uuid" }
        } else {
            log.trace("constructor(): TWO parsedIssue = ", parsedIssue)
            issue = parsedIssue
        }

        const source  = {
            // like: "fback-sim"
            like: "fback%"
        }
        
        this.state = {
            gl: null,
            variation: {
                  current: VARIATION,
                  A: "/idash/a",
                  B: "/idash/b",
            },
            isTrackingOpen: false,
            redirectBack: false,
            redirectToSDash: false,
            scrollerDirection: "down",
            rows: [],
            stats: [],
            // ok here we are
            // dataset: this.getDataset0(),
            dataset: [],
            tableDataset: [],
            highlights: [],
            // geoCodes: geoCodes,
//            localDash: localDash,
            showFilter: false,
//            issueUUID: "us-raisingthewage-issue-1",
            geo: geo,
            issue: issue,
            issueTrendDataset: [],
            statementTrendsDataset: [],
            source: source,
            viewOptions: {
                timeRange: "allWeeks"
            }
        }
    }

    initDashData = () => {
        log.trace("makeDashData")

        let data = [
            {uuid: "1", order: 1, txt: "Reason 1"},
            {uuid: "2", order: 2, txt: "Reason 2"},
            {uuid: "3", order: 3, txt: "Reason 3"}
        ]

        return data
    }

    /*
    handleChangeViewOptions = (event) => {

        const { viewOptions } = this.state
        if(event.target.name === "timeRangeLast14Days") {
            console.log("<SDash>: handleChangeViewOptions(): viewOptions =", viewOptions)
            const newViewOptions = (viewOptions.timeRange && viewOptions.timeRange === "last7Days")
                  ? {} // reset
                  : { timeRange: "last7Days"}
            this.setState({viewOptions: newViewOptions})


        
            const { geo, issue } = this.state
            
            const timeRange = {
	        //fromTimestamp: '2021-02-01:00:00.000Z',
                //	    toTimestamp: '2022-00-00T00:00:00.000Z'
                fromTimestamp: '2021-01-01T00:00:00.123Z',
                toTimestamp: '2022-01-01T00:00:00.123Z',
	    }

	    const rollups = ["WEEK"]

	    const v2Filters = {
	        geo: jsonSetPathValue({}, "address.state.code", "CA"),
	        issue: {
		    //slug: "california-gas-prices-sd13-issue"
                    slug: issue.slug // TODO: we're assuming that there is always an issue here
	        }
	    }
            
            this.fetchData(timeRange, rollups, v2Filters)
        }
    }
*/


    handleChangeViewOptions = (event) => {
        const { viewOptions, issue, geo } = this.state
        const { name } = event.target
        
        if(name === "last14Days"
           || name === "last30Days"
           || name === "allWeeks") {
            console.log("<SDash>: handleChangeViewOptions(): viewOptions =", viewOptions)
            console.log("<SDash>: handleChangeViewOptions(): name =", name)
            let newViewOptions
            let timeRange
            let rollups

	    const v2Filters = {
	        //geo: jsonSetPathValue({}, "address.state.code", "CA"),
                geo: this.mkFilterGeo(geo),
	        issue: {
		    //slug: "california-gas-prices-sd13-issue"
                    slug: issue.slug // TODO: we're assuming that there is always an issue here
	        }
	    }

            const setDefault =  () => {
                newViewOptions = { ...viewOptions, timeRange: "allWeeks"}
                timeRange = genTimeRange("default")
	        rollups  = ["WEEK"]
            }

            switch(name) {
            case "allWeeks":
                setDefault()
                break;
            case "last14Days":
            case "last30Days":
                
                if(viewOptions.timeRange !== name) {
                    newViewOptions = { ...viewOptions, timeRange: name}
                    timeRange = genTimeRange(name)
	            rollups  = ["DAY"]
                } else {
                    setDefault()
                }
                break;
            default:
                setDefault()
            }
            this.setState({viewOptions: newViewOptions})
            this.fetchData(timeRange, rollups, v2Filters)
        }
    }

    handleStatementTrendsResult = (result) => {
        log.trace("handleStatementTrendsResult(): this.state.issue.slug = ", this.state.issue.slug)
        log.trace("handleStatementTrendsResult(): result = ", result)


        // statement trends for all issues
        const allStatementTrends = result.data.statementTrends
        log.trace("handleStatementTrendsResult(): allStatementTrends =", allStatementTrends)

        const issueStatementTrends = allStatementTrends.filter(statementStat => 
                                                               ((this.state.issue.uuid && this.state.issue.uuid === statementStat.issue.uuid)
                                                                || (this.state.issue.slug && this.state.issue.slug === statementStat.issue.slug)))
        
        const groupedIssueStatementTrends = groupBy(issueStatementTrends, trend => {
            return `${trend.issue.slug}, ${trend.statement.slug}`
        })

        const groupedIssueStatementSortedTrends = groupSort(groupedIssueStatementTrends, (statA,statB) => {
            if(statA.YEAR_N > statB.YEAR_N) return 1 // reverse
            if(statA.WEEK_N > statB.WEEK_N) return 1 // reverse
            return -1 // don't reverse
        })
        
        //        log.trace("handleStatementTrendsResult(): before sort groupedIssueStatementTrends =",groupedIssueStatementTrends)
        //        log.trace("handleStatementTrendsResult(): after sort  groupedIssueStatementTrends =",groupedIssueStatementTrends)
        //        log.trace("handleStatementTrendsResult(): sorted =", sorted)

        
        // create a graph grend for each group, which is a single statement
        // similar to handleIssueTrend result, but for each one

        const graphDataset = []

        for (let key of Object.keys(groupedIssueStatementSortedTrends)) {
            log.trace("handleStatementTrendsResult(): key =",key)
            const statementTrend = groupedIssueStatementSortedTrends[key]
             log.trace("handleStatementTrendsResult(): statementTrend =",statementTrend)
             const graphTrend = addGraphTimestamps(statementTrend)
                   .map(stat => ({...stat, value:  stat.STATEMENT_FBACK_RANK}))
            log.trace("handleStatementTrendsResult(): graphTrend =", graphTrend)

            //trendSet.push(graphTrend) // this would be an array of arrays, each row for a statement, and inside of that array which is trend

            graphDataset.push({
                letter: graphTrend[0].statement.slug,
                txt: graphTrend[0].statement.slug,
                trend1: enrichTrend(graphTrend)
            })
            
        }

        log.debug("handleStatementTrendsResult(): graphDataset =", graphDataset)
        this.setState({statementTrendsDataset: graphDataset})
        
    }


    handleStatementV2Results = (result) => {
        this.handleStatementTrendsV2Result(result)
        this.handleStatementTableV2Result(result)
    }


    handleStatementTrendsV2Result = (result) => {
        log.trace("handleStatementTrendsV2Result(): V2: this.state.issue.slug = ", this.state.issue.slug)
        log.trace("handleStatementTrendsV2Result(): V2: result = ", result)

        // statement trends for all issues
        const allStatementTrends = result.data.statementTrendsV2
        log.trace("handleStatementTrendsV2Result(): allStatementTrends =", allStatementTrends)

        const issueStatementTrends = allStatementTrends.filter(statementStat => 
                                                               ((this.state.issue.uuid && this.state.issue.uuid === statementStat.issue.uuid)
                                                                || (this.state.issue.slug && this.state.issue.slug === statementStat.issue.slug)))
        
        const groupedIssueStatementTrends = groupBy(issueStatementTrends, trend => {
            return `${trend.issue.slug}, ${trend.statement.slug}`
        })

        const groupedIssueStatementSortedTrends = groupSort(groupedIssueStatementTrends, (statA,statB) => {
            if(statA.YEAR_N > statB.YEAR_N) return 1 // reverse
            if(statA.WEEK_N > statB.WEEK_N) return 1 // reverse
            return -1 // don't reverse
        })
        
        //        log.trace("handleStatementTrendsResult(): before sort groupedIssueStatementTrends =",groupedIssueStatementTrends)
        //        log.trace("handleStatementTrendsResult(): after sort  groupedIssueStatementTrends =",groupedIssueStatementTrends)
        //        log.trace("handleStatementTrendsResult(): sorted =", sorted)

        
        // create a graph grend for each group, which is a single statement
        // similar to handleIssueTrend result, but for each one

        const graphDataset = []

        for (let key of Object.keys(groupedIssueStatementSortedTrends)) {
            log.trace("handleStatementTrendsV2Result(): key =",key)
            const statementTrend = groupedIssueStatementSortedTrends[key]
             log.trace("handleStatementTrendsV2Result(): DAILY: statementTrend =",statementTrend)
             const graphTrend = addGraphTimestamps(statementTrend)
                   .map(stat => ({...stat, value:  stat.STATEMENT_FBACK_RANK}))
            log.trace("handleStatementTrendsV2Result(): DAILY: graphTrend =", graphTrend)

            //trendSet.push(graphTrend) // this would be an array of arrays, each row for a statement, and inside of that array which is trend

            graphDataset.push({
                letter: graphTrend[0].statement.slug,
                txt: graphTrend[0].statement.slug,
                trend1: enrichTrend(graphTrend)
            })
            
        }

        log.trace("handleStatementTrendsResult(): graphDataset =", graphDataset)
        this.setState({statementTrendsDataset: graphDataset})
        
    }
    

    handleStatementTrendsError = (error) => {
        log.trace("handleStatementTrendsError(): error = ", JSON.stringify(error,null," "))
    }
    
    handleStatementTableV2Result = (result) => {
        log.debug("handleStatementTableResult(): V2: result = ", result)
        log.debug("handleStatementTableResult(): V2: this.state.issue = ", this.state.issue)
        // statement trends for all issues
        const allStatementTrends = result.data.statementTrendsV2
        log.trace("handleStatementTableResult(): allStatementTrends =",allStatementTrends)

        const issueStatementTrends = allStatementTrends.filter(statementStat => ((this.state.issue.uuid && this.state.issue.uuid === statementStat.issue.uuid)
                                                                                 || (this.state.issue.slug && this.state.issue.slug === statementStat.issue.slug)))

        log.debug("handleStatementTableResult(): V2: issueStatementTrends =", issueStatementTrends)

        // for for fun
        const groupedIssueStatementTrends = groupBy(issueStatementTrends, trend => {
            return `${trend.issue.slug}, ${trend.statement.slug}`
        })

        log.debug("handleStatementTableResult(): V2: groupedIssueStatementTrends =",groupedIssueStatementTrends)
        
        const calcs = calcStatementTableDatasetTailV2(issueStatementTrends, 56)
        log.debug("handleStatementTableResult(): V2: calcs = ", calcs)

        const tableDataset = calcs.resultDataset.map(s => {
            log.trace("handleStatementTableResult(): s = ", s)
            return {
                // for DashTable
                column1: {
                    val: s.statement.txt,
                    uuid: s.statement.uuid,
                    slug: s.statement.slug
                },
                column2: {
                    val: s.AGG_STATEMENT_FBACK_RANK_AVG
                },

                column3: {
                    // val: "Federal"
                    val: `${s.issue.level[0].toUpperCase()}${s.issue.level.slice(1)}`
                },
                
                // for DashBarChart
                name: s.statement.txt,
                col1: s.AGG_STATEMENT_FBACK_COUNT,
                // col2: s.STATEMENT_FBACK_COUNT/2, // not being used
                // col3: s.STATEMENT_FBACK_COUNT * 0.7, // 0.7 is pro ratio
                //col3: s.STATEMENT_FBACK_COUNT * Math.floor((Math.random() * 9) + 0) / 10,
                col3: s.AGG_STATEMENT_FBACK_POSITIVE_RATIO_AVG,
                // mark1: s.STATEMENT_FBACK_COUNT * 0.5
                //mark1: Math.floor((Math.random() * s.STATEMENT_FBACK_COUNT) + 0),
                mark1: s.AGG_STATEMENT_FBACK_LAST_WEEK_COUNT
            }
        })

        log.trace("handleStatementTableResult(): tableDataset =", tableDataset)
        log.trace("handleStatementTableResult(): setting state with tableDataset")
        this.setState({tableDataset: tableDataset})
    }

    handleStatementTableResult = (result) => {
        log.debug("handleStatementTableResult(): VIEWFIX: result = ", result)
        log.debug("handleStatementTableResult(): VIEWFIX: this.state.issue = ", this.state.issue)
        // this.state.issue here is wrong, it has uuid as slug

        
        // statement trends for all issues
        const allStatementTrends = result.data.statementTrends
        log.trace("handleStatementTableResult(): allStatementTrends =",allStatementTrends)


        // trends of statements just for this single issue
        // each statement for this issue has a trend that's multiple stats
        const issueStatementTrends = allStatementTrends.filter(statementStat => ((this.state.issue.uuid && this.state.issue.uuid === statementStat.issue.uuid)
                                                                                 || (this.state.issue.slug && this.state.issue.slug === statementStat.issue.slug)))

        log.trace("handleStatementTableResult(): issueStatementTrends =",issueStatementTrends)

        // for for fun
        const groupedIssueStatementTrends = groupBy(issueStatementTrends, trend => {
            return `${trend.issue.slug}, ${trend.statement.slug}`
        })

        log.trace("handleStatementTableResult(): groupedIssueStatementTrends =",groupedIssueStatementTrends)
        
        const calcs = calcStatementTableDatasetTail(issueStatementTrends, 56)
        log.trace("handleStatementTableResult(): calcs = ", calcs)


        const tableDataset = calcs.resultDataset.map(s => {
            log.trace("handleStatementTableResult(): s = ", s)
            return {
                // for DashTable
                column1: {
                    val: s.statement.txt,
                    uuid: s.statement.uuid,
                    slug: s.statement.slug
                },
                column2: {
                    val: s.AGG_STATEMENT_FBACK_RANK_AVG
                },

                column3: {
                    // val: "Federal"
                    val: `${s.issue.level[0].toUpperCase()}${s.issue.level.slice(1)}`
                },
                
                // for DashBarChart
                name: s.statement.txt,
                col1: s.AGG_STATEMENT_FBACK_COUNT,
                // col2: s.STATEMENT_FBACK_COUNT/2, // not being used
                // col3: s.STATEMENT_FBACK_COUNT * 0.7, // 0.7 is pro ratio
                //col3: s.STATEMENT_FBACK_COUNT * Math.floor((Math.random() * 9) + 0) / 10,
                col3: s.AGG_STATEMENT_FBACK_POSITIVE_RATIO_AVG,
                // mark1: s.STATEMENT_FBACK_COUNT * 0.5
                //mark1: Math.floor((Math.random() * s.STATEMENT_FBACK_COUNT) + 0),
                mark1: s.AGG_STATEMENT_FBACK_LAST_WEEK_COUNT
            }
        })

        log.trace("handleStatementTableResult(): tableDataset =", tableDataset)
        log.trace("handleStatementTableResult(): setting state with tableDataset")
        this.setState({tableDataset: tableDataset})
        
    }

    handleStatementTableError = (error) => {
        log.debug("handleStatementTableError(): error = ", JSON.stringify(error,null," "))
    }


    handleStatementError = (error) => {
        log.debug("handleStatementError(): error = ", JSON.stringify(error,null," "))
    }
    


    handleIssueV2Results = (result) => {
        this.handleIssueTrendsV2Result(result)
    }

    
    handleIssueTrendsV2Result = (result) => {
        log.debug("handleIssueV2Results(): V2_ISSUE: result = ", result)

        if(!result.data) return
        log.trace("handleIssueTrendResult(): result.data = ", result.data)
        // currently result.data returls all the issues for all the weeks and we filter it here
        // we should have a separate call to db, to actually get that stuff from DB later

        const allIssueTrends = result.data.issueTrendsV2

        log.debug("handleIssueV2Results(): V2_ISSUE: allIssueTrends =", allIssueTrends)
        
        // filter-in only the one issue for this view
//        const issueTrend = allIssueTrends.filter(issueStat => ((this.state.issue.uuid && this.state.issue.uuid === issueStat.issue.uuid)
//                                                               || (this.state.issue.slug && this.state.issue.slug === issueStat.issue.slug)))
//

        const issueTrend = allIssueTrends 
        
        log.debug("handleIssueV2Results(): V2_ISSUE: issueTrend =", issueTrend)
        
        const graphTrend = addGraphTimestamps(issueTrend)
              .map(stat => ({...stat, value:  stat.ISSUE_FBACK_RANK}))
        
        const richTrend = enrichTrend(graphTrend)
                
        log.debug("handleIssueTrendResult(): issueTrend = ", issueTrend)
        log.debug("handleIssueTrendResult(): graphTrend = ", graphTrend)
        log.debug("handleIssueTrendResult(): richTrend = ", richTrend)

        // we ignore any other values here, don't need them
        const trendDataset = [{
            //col1: 2000,
            //col2: 600,
            //letter: "just trend",
            trend1: richTrend
        }]

        log.trace("handleIssueTrendResult(): trendDataset = ", trendDataset)
        
        this.setState({issueTrendDataset: trendDataset})
        
    }

    handleIssueV2Error = (error) => {
        log.debug("handleIssueV2Error(): error = ", JSON.stringify(error,null," "))
    }

    handleIssueTrendResult = (result) => {
        log.trace("handleIssueTrendResult(): start...")
        if(!result.data) return
        log.trace("handleIssueTrendResult(): result.data = ", result.data)
        // currently result.data returls all the issues for all the weeks and we filter it here
        // we should have a separate call to db, to actually get that stuff from DB later

        const allIssueTrends = result.data.issueTrends

        log.trace("handleIssueTrendResult(): allIssueTrends =", allIssueTrends)
        
        // filter-in only the one issue for this view
        const issueTrend = allIssueTrends.filter(issueStat => ((this.state.issue.uuid && this.state.issue.uuid === issueStat.issue.uuid)
                                                               || (this.state.issue.slug && this.state.issue.slug === issueStat.issue.slug)))

        const graphTrend = addGraphTimestamps(issueTrend)
              .map(stat => ({...stat, value:  stat.ISSUE_FBACK_RANK}))
        
        const richTrend = enrichTrend(graphTrend)
                
        log.debug("handleIssueTrendResult(): issueTrend = ", issueTrend)
        log.debug("handleIssueTrendResult(): graphTrend = ", graphTrend)
        log.debug("handleIssueTrendResult(): richTrend = ", richTrend)

        // we ignore any other values here, don't need them
        const trendDataset = [{
            //col1: 2000,
            //col2: 600,
            //letter: "just trend",
            trend1: richTrend
        }]

        log.trace("handleIssueTrendResult(): trendDataset = ", trendDataset)
        
        this.setState({issueTrendDataset: trendDataset})
        
    }
    
    handleResult = (result) => {
        log.trace("handleResult(): I m HERE result = ", JSON.stringify(result,null," "))

        const stats = result.data.stats
        log.trace("handleResult(): stats.length = ", stats.length)

        // the dataset for the table
        const dataset = _.map(result.data.stats, stat => {
            log.trace("handleResult(): stat = ", stat)
            log.trace(`handleResult(): stat: issue.txt = ${stat.issue.txt}, ALL_RANK=${stat.ALL_RANK}`)
            return {
                // for DashTable
                issue: {
                    txt: stat.issue.txt
                },
                allRank: stat.ALL_RANK,
                // for DashMap and other Sub
                user: {
                    geo: {
                        state: {
                            code: stat.user.geo.state.code,
                            name: stat.user.geo.state.name
                        },
                        uscd: {
                            code: stat.user.geo.uscd.code
                        },
                        zip: {
                            code: stat.user.geo.zip.code,
                            plus4: stat.user.geo.zip.plus4
                        }
                    }
                },
                // for DashBarChart
                name: stat.issue.txt,
                col1: stat.ALL_COUNT,
                col2: stat.ALL_COUNT_LAST_WEEK,
                stat: stat
            }
        })

        log.trace("handleResult(): dataset = ", dataset)

        /*
        this.setState({
            ...this.state,
            dataset: dataset
        })
        */
    }



    handleError = (error) => {
        log.trace("handleError(): error = ", JSON.stringify(error,null," "))
    }

    handleIssueTrendError = (error) => {
        log.trace("handleIssueTrendError(): error = ", JSON.stringify(error,null," "))
    }
    

    fetchData = (timeRange, rollups, v2Filters) => {
        log.debug("fetchData(): V2_ISSUE: timeRange = ", timeRange)
        log.debug("fetchData(): V2_ISSUE: rollups = ", rollups)
        log.debug("fetchData(): V2_ISSUE: v2Filters = ", v2Filters)
        log.debug("fetchData(): V2_ISSUE: geo = ", JSON.stringify(v2Filters.geo))

        getIssueTrendsV2(timeRange, rollups, v2Filters, {
            onResult: this.handleIssueV2Results,
            onError: this.handleIssueV2Error
	})

        getStatementTrendsV2(timeRange, rollups, v2Filters, {
            onResult: this.handleStatementV2Results,
            onError: this.handleStatementError
	})

    }


    fetchData_old1 = (timeRange, rollups, v2Filters) => {
        log.debug("fetchData(): V2: this.state.geo =", this.state.geo)
        log.debug("fetchData(): V2: this.state.issue.slug = ", this.state.issue.slug)
        log.debug("fetchData(): V2: timeRange = ", timeRange)
        log.debug("fetchData(): V2: rollups = ", rollups)
        log.debug("fetchData(): V2: v2Filters = ", v2Filters)

        const { geo } = this.state

        const source = this.state.source
        log.trace("fetchData(): V2: source = ", source)
        
        let filters = {
            sourceLike: source.like,
        }

        let thisGeoLevel
        
        switch(geo.level) {
        case "NATIONAL":
            thisGeoLevel = geo.level
            filters = {
                ...filters
            }
            break
        case "STATE":
            thisGeoLevel = geo.level
            filters = {
                ...filters,
                stateCode: geo.stateCode
            }
            break
        case "USCD":
            thisGeoLevel = geo.level
            filters = {
                ...filters,
                stateCode: geo.stateCode,
                uscdCode: geo.uscdCode
            }
            break
        case "SSD":
            thisGeoLevel = geo.level
            filters = {
                ...filters,
                stateCode: geo.stateCode,
                ssdCode: geo.ssdCode
            }
            break
        case "ZIP":
            thisGeoLevel = geo.level
            filters = {
                ...filters,
                zipCode: geo.zipCode
            }
            break
        default:
        }

        //log.debug("componentDidMount(): VIEWFIX: calling getIssueTrends() for issue trend with geo.level =", geo.level)
        //log.debug("componentDidMount(): VIEWFIX: calling getIssueTrends() for issue trend with thisGeoLevel =", thisGeoLevel)
        //log.debug("componentDidMount(): VIEWFIX: calling getIssueTrends() for issue trend with filters =", filters)



        log.debug("fetchData(): VIEWFIX: calling getIssueTrendsV2 with timeRange =", timeRange)
        log.debug("fetchData(): VIEWFIX: calling getIssueTrendsV2 with rollups =", rollups)
        log.debug("fetchData(): VIEWFIX: calling getIssueTrendsV2 with v2Filters =", v2Filters)

        
        //
        // ISSUE TREND CHARTS
        //
        //getIssueTrends(thisGeoLevel, "NA",
	//{
        //onResult: this.handleIssueTrendResult,
        //onError: this.handleIssueTrendResult},
	//filters)

        //
        // V2
        //
        getIssueTrendsV2(timeRange, rollups, v2Filters, {
            onResult: this.handleIssueV2Results,
            onError: this.handleIssueV2Error
	})

        //
        // STATEMENT TABLE
        //
        getStatementTrendsV2(timeRange, rollups, v2Filters, {
            onResult: this.handleStatementV2Results,
            onError: this.handleStatementError
	})

        // before consolidate
        /*
        getStatementTrendsV2(timeRange, rollups, v2Filters, {
            onResult: this.handleStatementTableV2Result,
            onError: this.handleStatementTableError
	})

	getStatementTrendsV2(timeRange, rollups, v2Filters, {
            onResult: this.handleStatementTrendsV2Result,
            onError: this.handleStatementTrendsError
        })
        */
        
        /*
        //
        // STATEMENT TABLE
        //
        getStatementTrends(thisGeoLevel, "NA",
                           {
                               onResult: this.handleStatementTableResult,
                               onError: this.handleStatementTableError
                           },
                           filters)

        //
        // STATEMENT TRENDS CHART
        //
       getStatementTrends(thisGeoLevel, "NA",
                           {
                               onResult: this.handleStatementTrendsResult,
                               onError: this.handleStatementTrendsError
                           },
                          filters)
        */
    }


    mkFilterGeo = (geo) => {
        let filterGeo
        switch(geo.level) {
        case "SSD":
            if(geo.ssdCode) filterGeo = jsonSetPathValue(filterGeo, "ssd.code", geo.ssdCode)
        case "USCD":
            if(geo.uscdCode) filterGeo = jsonSetPathValue(filterGeo, "uscd.code", geo.uscdCode)
        case "STATE":
            if(geo.stateCode) filterGeo = jsonSetPathValue(filterGeo, "address.state.code", geo.stateCode)
        case "ZIP":
            if(geo.zipCode) filterGeo = jsonSetPathValue(filterGeo, "address.zip.code", geo.zipCode)
        case "NATIONAL":
        default:
        }
        return filterGeo
    }

    componentDidMount = () => {
        window.addEventListener("scroll", this.handleScroll);
        if(this.headDivEl) this.scrollToTop()
        document.querySelector("body").style.overflowY = "scroll" // aways how scrollbar

        const { geo, issue } = this.state

        log.debug("componentDidMount(): V2_ISSUE: issue =", issue)
        log.debug("componentDidMount(): V2_ISSUE: geo =", geo)
        
        const timeRange = genTimeRange("default")

	const rollups = ["WEEK"]

	let v2Filters = {
	    issue: {
		//slug: "california-gas-prices-sd13-issue"
                slug: issue.slug // TODO: we're assuming that there is always an issue here
	    },
            geo: this.mkFilterGeo(geo)
	}

        this.fetchData(timeRange, rollups, v2Filters)
        
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll)
    }

    handleScroll = (event) => {
        // log.trace("<Issues>: handleScroll(): event = ", event)
        if(!this.state.scrollerDirection) {
            this.setState({scrollerDirection: "down"})
            return
        }

        const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight,  html.scrollHeight, html.offsetHeight);
        const windowBottom = windowHeight + window.pageYOffset;

        log.trace("handleScroll(): window.pageYOffset =", window.pageYOffset)

        if (windowBottom >= (docHeight - 1)) {
            this.setState({scrollerDirection: "up"})
        } else if(window.pageYOffset === 0) {
            this.setState({scrollerDirection: "down"})
        }
    }

    scrollToBottom = () => {
        log.trace("scrollToBottom(): this.contentDivEl = ", this.contentDivEl)
        log.trace("scrollToBottom(): this.tailDivEl = ", this.tailDivEl)
        
        this.tailDivEl.scrollIntoView({
            behavior: "smooth",
            block: "start",
        })
    }

    scrollToTop = () => {
        log.trace("scrollToBottom(): this.headDivEl = ", this.headDivEl)
        log.trace("scrollToBottom(): this.tailDivEl = ", this.tailDivEl)
        
        this.headDivEl.scrollIntoView({
            behavior: "smooth",
            block: "start",
        })
    }

    handleIssueChange = (issueUUID, issueTxt) => () => {
        log.trace("handleIssueChange(): issueUUID =", issueUUID)
        log.trace("handleIssueChange(): issueTxt =", issueTxt)
        log.trace("handleIssueChange(): filters =", this.state.filters)


        let localGL = JSON.parse(localStorage.getItem("gl"))
        log.trace("handleIssueChange(): localGL =", localGL)

        // let localGL = JSON.parse(localStorage.getItem("gl"))
        // At least at the prototype stage, we'll proabbly
        // arrive at this page directly without any registration
        // sometimes, so make sure we can do that by creating
        // gl in the fly if needed
        if(!localGL) localGL = {}
        if(!localGL.sdash) localGL.sdash = {}
        localGL.sdash.currentIssueUUID = issueUUID
        localGL.sdash.currentIssueTxt = issueTxt
        localGL.sdash.currentFilters = this.state.filters
        localStorage.setItem("gl", JSON.stringify(localGL))
        
        this.setState({redirectToSDash: true})

    }

    handleTableChange = (filters, rows) => {
        log.trace("handleTableChange(): filters =", filters)
        log.trace("handleTableChange(): rows =", rows)

        this.setState({
            ...this.state,
            filters: filters,
            rows: rows,
        })
    }

    handleMapFilterClick = () => {
        log.trace("handleMapFilterClick()")
        this.setState({showFilter: !this.state.showFilter})
    }


    enrichTrendDataDesc = (data) => {
        let prevValue
        let flashItemNumber = 1
        let flashItemDirection
        let flashItemType
        let itemLastNumber = data.length
        
        const enrichedData = data
	      .sort((a,b) => {
	          const am = moment(a.timestamp)
	          const bm = moment(b.timestamp)
	          return am.diff(bm)
	      })    
	      .map(d => {
	          if(flashItemNumber === itemLastNumber) {
		      flashItemType = "current"
	          } else if(flashItemNumber === (itemLastNumber - 1)) {
		      flashItemType = "lastWeek"
	          } else {
                      flashItemType = undefined
                  }
	          if(prevValue) {
		      if(prevValue < d.value) {
		          flashItemDirection = "up"
		      } else if(prevValue > d.value) {
		          flashItemDirection = "down"
		      } else {
		          flashItemDirection = "same"
		      }
	          } else {
		      flashItemDirection = "same"
                  }
	          prevValue = d.value
	          return {
		      ...d,
		      flashValue: d.value,
		      flashTimestamp: moment(d.timestamp).toDate(),
		      flashItemNumber: flashItemNumber++,
		      flashItemType: flashItemType,
		      flashItemDirection: flashItemDirection
	          }
	      })
        return enrichedData
    }
    

    getDataset0() {
        const dataset = [
            {
                name: "A",
                col1: 0,
                col2: 0
            },
//            {
//                name: "B",
//                col1: 0,
//                col2: 0
//            }
        ]
        return dataset
    }


    getDataset1() {
        const dataset = [
            {
                name: "A",
                col1: 1000,
                col2: 2000
            },
            {
                name: "B",
                col1: 3000,
                col2: 1500
            }
        ]
        return dataset
    }



    getReasonsDataset() {
        // eslint-disable-next-line
        const dataset2 = [
            {
                letter: "A",
                col1: 1000,
                col2: 2000
            },
            {
                letter: "B",
                col1: 3000,
                col2: 1500
            }
        ]
        // eslint-disable-next-line
        const dataset3 = [
            {
                letter: "A",
                col1: 1000, // bar1
                col2: 500, // bar2
                trend1: [
                    {value: 50, timestamp: "2020-06-14 00:00:00.00000+00"},
                    {value: 30, timestamp: "2020-05-17 00:00:00.00000+00"},
                    {value: 50, timestamp: "2020-05-24 00:00:00.00000+00"},
                    {value: 20, timestamp: "2020-06-07 00:00:00.00000+00"}, 
                    {value: 40, timestamp: "2020-05-31 00:00:00.00000+00"}, 
                    {value: 70, timestamp: "2020-06-17 00:00:00.00000+00"}
                ]
            },
            {
                letter: "B",
                col1: 2000, // bar1
                col2: 600, // bar2
                trend1: [
                    {value: 60, timestamp: "2020-06-14 00:00:00.00000+00"},
                    {value: 40, timestamp: "2020-05-17 00:00:00.00000+00"},
                    {value: 60, timestamp: "2020-05-24 00:00:00.00000+00"},
                    {value: 30, timestamp: "2020-06-07 00:00:00.00000+00"}, 
                    {value: 10, timestamp: "2020-05-31 00:00:00.00000+00"}, 
                    {value: 15, timestamp: "2020-06-17 00:00:00.00000+00"}
                ]
            }
        ]

        // here we're taking an array of line/trend data
        // and enriching it with bunch of d.flash* attributes
        const enrichTrendData = (data) => {
            let prevValue
            let flashItemNumber = 1
            let flashItemDirection
            let flashItemType
            
            const enrichedData = data
	          .sort((a,b) => {
	              const am = moment(a.timestamp)
	              const bm = moment(b.timestamp)
	              return am.diff(bm)
	          })    
	          .map(d => {
	              if(flashItemNumber === 6) {
		          flashItemType = "current"
	              } else if(flashItemNumber === 5) {
		          flashItemType = "lastWeek"
	              }
	              if(prevValue) {
		          if(prevValue < d.value) {
		              flashItemDirection = "up"
		          } else if(prevValue > d.value) {
		              flashItemDirection = "down"
		          } else {
		              flashItemDirection = "same"
		          }
	              }
	              prevValue = d.value
	              return {
		          ...d,
		          flashValue: d.value,
		          flashTimestamp: moment(d.timestamp).toDate(),
		          flashItemNumber: flashItemNumber++,
		          flashItemType: flashItemType,
		          flashItemDirection: flashItemDirection
	              }
	          })
            return enrichedData
        }

        const enrichedDataset = dataset3.map(d => {
            return {
                ...d,
                trend1: enrichTrendData(d.trend1)
            }
        })

        return enrichedDataset
    }


    getIssueDataset() {
        // eslint-disable-next-line
        const dataset2 = [
            {
                letter: "A",
                col1: 1000,
                col2: 2000
            },
            {
                letter: "B",
                col1: 3000,
                col2: 1500
            }
        ]
        // eslint-disable-next-line
        const dataset3 = [
            /*
            {
                letter: "A",
                col1: 1000, // bar1
                col2: 500, // bar2
                trend1: [
                    {value: 50, timestamp: "2020-06-14 00:00:00.00000+00"},
                    {value: 30, timestamp: "2020-05-17 00:00:00.00000+00"},
                    {value: 50, timestamp: "2020-05-24 00:00:00.00000+00"},
                    {value: 20, timestamp: "2020-06-07 00:00:00.00000+00"}, 
                    {value: 40, timestamp: "2020-05-31 00:00:00.00000+00"}, 
                    {value: 70, timestamp: "2020-06-17 00:00:00.00000+00"}
                ]
            },
*/
            {
                letter: "B",
                col1: 2000, // bar1
                col2: 600, // bar2
                trend1: [
                    {value: 60, timestamp: "2020-06-14 00:00:00.00000+00"},
                    {value: 40, timestamp: "2020-05-17 00:00:00.00000+00"},
                    {value: 60, timestamp: "2020-05-24 00:00:00.00000+00"},
                    {value: 30, timestamp: "2020-06-07 00:00:00.00000+00"}, 
                    {value: 10, timestamp: "2020-05-31 00:00:00.00000+00"}, 
                    {value: 15, timestamp: "2020-06-17 00:00:00.00000+00"}
                ]
            }
        ]

        // here we're taking an array of line/trend data
        // and enriching it with bunch of d.flash* attributes
        const enrichTrendData = (data) => {
            let prevValue
            let flashItemNumber = 1
            let flashItemDirection
            let flashItemType
            
            const enrichedData = data
	          .sort((a,b) => {
	              const am = moment(a.timestamp)
	              const bm = moment(b.timestamp)
	              return am.diff(bm)
	          })    
	          .map(d => {
	              if(flashItemNumber === 6) {
		          flashItemType = "current"
	              } else if(flashItemNumber === 5) {
		          flashItemType = "lastWeek"
	              }
	              if(prevValue) {
		          if(prevValue < d.value) {
		              flashItemDirection = "up"
		          } else if(prevValue > d.value) {
		              flashItemDirection = "down"
		          } else {
		              flashItemDirection = "same"
		          }
	              }
	              prevValue = d.value
	              return {
		          ...d,
		          flashValue: d.value,
		          flashTimestamp: moment(d.timestamp).toDate(),
		          flashItemNumber: flashItemNumber++,
		          flashItemType: flashItemType,
		          flashItemDirection: flashItemDirection
	              }
	          })
            return enrichedData
        }

        const enrichedDataset = dataset3.map(d => {
            return {
                ...d,
                trend1: enrichTrendData(d.trend1)
            }
        })

        return enrichedDataset
    }

    

    handleRowHover_old = row => {
        log.trace("handleRowHover(): row =", row)
        const fullStats = _.filter(this.state.dataset, d => {
            // TODO: find by txt, not uuid yet
            return (d.issue) && (d.issue.txt) && (d.issue.txt === row.issue)
        })
        log.trace("handleRowHover(): fullStats =", fullStats)
        
        let highlights = _.map(fullStats, s => {
            if (s.stat.SUB_RANK > 1) return {
                subName: s.user.geo.uscd.code,
                color: "green"
            }
            else return null
        })

        log.trace("handleRowHover(): highlights =", highlights)
        
        this.setState({
            ...this.state,
            highlights: highlights
        })
    }


    handleRowHover = row => {
        log.trace("handleRowHover(): row =", row)
//        log.trace("handleRowHover(): this.state.dataset =", this.state.dataset)
//        log.trace("handleRowHover(): this.state.statementTrendsDataset =", this.state.statementTrendsDataset)


        //const statementUUID = row.column1.uuid
        //
        //        let highlights = [{letter: statementUUID}]

        const statementSlug = row.column1.slug

        const newHighlights = [{letter: statementSlug}]
        

        log.trace("handleRowHover(): newHighlights =", newHighlights)
        
        this.setState({
            ...this.state,
            highlights: newHighlights
        })
    }

    
    handleRowHover_old_new = row => {
        log.trace("handleRowHover(): row =", row)
        log.trace("handleRowHover(): this.state.dataset =", this.state.dataset)
        log.trace("handleRowHover(): this.state.statementTrendsDataset =", this.state.statementTrendsDataset)


        const statementUUID = row.item.uuid

        let highlights = [{letter: statementUUID}]

        log.trace("handleRowHover(): highlights =", highlights)
        
        this.setState({
            ...this.state,
            highlights: highlights
        })
    }
    
            
    handleRowUnhover = row => {
        log.trace("handleRowUnhover(): row =", row)
        const hightlights = []
        this.setState({
            ...this.state,
            highlights: hightlights
        })
    }
    
    render() {
        const { classes } = this.props

        // redirects first
        if(this.state.redirectToSDash) {
            log.trace("render(): redirect to SDash")
            return <Redirect push to="/sdash"/>
        } else if(this.state.redirectToIDashState) {
            return <Redirect push to="/idash-state"/>
        }

//        let showFilter = true
        let gridMd, gridSm,
            // eslint-disable-next-line            
            filterMd,
            // eslint-disable-next-line
            filterSm,
            // eslint-disable-next-line            
            issueTrendMd,
            // eslint-disable-next-line            
            issueTrendSm,
            chartsMd, chartsSm
        let mainDivClass

        if(this.state.showFilter) {
            issueTrendMd = 12
            issueTrendSm = 12
            filterMd = 2
            filterSm = 12
            gridMd = 5
            gridSm = 12
            mainDivClass = classes.mainDivFilter
        } else {
            chartsMd = 6
            chartsSm = 12
            issueTrendMd = 12
            issueTrendSm = 12
            filterMd = 0
            filterSm = 0
            gridMd = 6
            gridSm = 12
            mainDivClass = classes.mainDiv
        }


        let viewLabel = "Issue Detail View"
        let geo = this.state.geo
        
        switch(geo.level) {
        case "USCD":
            //            viewLabel = `${viewLabel} - ${geo.stateCode}-${geo.uscdCode}`
            // viewLabel = `${viewLabel} - ${geo.stateName}-${geo.uscdName}`
            //viewLabel = `${viewLabel} - Californian District 18`
            viewLabel = `${viewLabel} - ${geo.stateCode}-${geo.uscdCode}`

            break
        case "STATE":
            viewLabel = `${viewLabel} - ${geo.stateCode}`
            break
        case "NATIONAL":
            viewLabel = `${viewLabel} - National`
            break
        default:
        }
        
	return(
            <React.Fragment>
	      <CssBaseline/>

              <div ref={(el) => { this.headDivEl = el }} ></div>

              <FlashTopBar text="Issue Detail Dashboard" variation={this.state.variation}/>
              
               <div className={mainDivClass}>
                 
                 <FlashHeader text={viewLabel}/>

                 <Typography className={classes.subheaderText} variant="h6" style={{fontSize: 28, color:"#448cff", marginLeft: 25, marginTop: 20, marginBottom: 10, marginRight: 25}}>
                   - {this.state.issue.txt}
                </Typography>



                 <div className={classes.sectionHeaderDiv}>
                   <div style={{paddingLeft: "1em", paddingRight: "1em"}}>
                     <div style={{display: "inline", paddingLeft: "0.8em"}}>
            {/*
                       <FormControlLabel control={<GreenCheckbox checked={this.state.viewOptions.timeRange === "last4Days"} onChange={this.handleChangeViewOptions}/>} label="Last 7 Days" name="timeRangeLast14Days"/>
             */}
                       <FormControlLabel control={<GreenCheckbox checked={this.state.viewOptions.timeRange === "allWeeks"} onChange={this.handleChangeViewOptions}/>} label="Weekly for all time" name="allWeeks"/>
                       <FormControlLabel control={<GreenCheckbox checked={this.state.viewOptions.timeRange === "last14Days"} onChange={this.handleChangeViewOptions}/>} label="Daily for last 14 days" name="last14Days"/>
                       <FormControlLabel control={<GreenCheckbox checked={this.state.viewOptions.timeRange === "last30Days"} onChange={this.handleChangeViewOptions}/>} label="Daily for last 30 days" name="last30Days"/>
                     </div>
                   </div>
                 </div>
                 

                <Grid container classes={{
                    container: classes.gridContainer
                }} spacing={2}>


                  <Grid item md={chartsMd} sm={chartsSm}>
                    <div style={{
                        height: 300,
                        // backgroundColor: "grey"
                    }}>
                    <DashTrend dataset={this.state.issueTrendDataset}
                               header1="The Importance of Issue Over Time"
                               header2="Ranks over time"
                               reverseY={true}
                               showHighlights={false}
                    />
                    </div>

                    <div style={{
                        height: 500,
//                        backgroundColor: "grey"
                    }}>
                      <DashTrend
                        dataset={this.state.statementTrendsDataset}
                        header1="The Importance of Reasons Over Time"
                        header2="Ranks over time"
                        showHighlights={true}
                        startEmpty={true}
                        reverseY={true}
                        highlights={this.state.highlights}
                      />
                    </div>


                  </Grid>
                  
                  <Grid item md={gridMd} sm={gridSm}>
                    <div style ={{
                        marginTop: 18,
                        height: 300,
                        display: "flex",
                        // justifyContent: "center",
                        alignItems: "top",
                    }}>
                    
                    <div style={{
                        height: "80px",
                        // backgroundColor: "grey"
                    }}>
                    <DashInfo dataset={this.state.issueTrendDataset}
                               header1="Info"
                               // header2="Issue trend reflect the importance assigned by constituents"
                               text1="Issue trend reflects the importance assigned by constituents"
                               reverseY={true}
                               showHighlights={false}/>
                    </div>
                    </div>
                    
                    <div style={{
                        height: "500px",
                        // backgroundColor: "grey"
                    }}>
                      <DashTable
                        info="reasons"
                        header1="Reasons"
                        header2="Hover over an issue to see its trend"
                        txtName="Reason"
                        showPlace={false}
                        showBar2={false}
                        showBar3={true}
                        showMark1={true}
                        dataset={this.state.tableDataset}
                        onRowHover={this.handleRowHover}
                        onRowUnhover={this.handleRowUnhover}
                      />
                    </div>
                  </Grid>
                </Grid>

                {/*
                  * OLD CHARTS BEGIN
                  */}

                {/*
                   <FlashIDashStateTable
                   topFilters={this.state.filters}
                   onIssueChange={this.handleIssueChange}
                   onTableChange={this.handleTableChange}
                   />
                   <div style={{padding: 20}}></div>
                   <Paper>
                   <FlashIssueCountsMap topFilters={this.state.filters} rows={this.state.rows} height="500px"/>
                   </Paper>
                   <div style={{padding: 20}}></div> 
                   <Paper>
                   <FlashIssueTrendsChart chartID="A" title="Top 5 Issues Rank Trend" rows={this.state.rows}/>
                   </Paper>
                   <div style={{padding: 20}}></div> 
                   <Paper>
                   <Flash2SidesChart
                   title={"Pros And Cons"}
                   rows={this.state.row}/>
                   </Paper>
                 */}
                
                {/*
                  * OLD CHARTS END
                  */}
                
              </div>


              { this.state.scrollerDirection && this.state.scrollerDirection === "down" &&
                <Fab aria-label="scroll"
                     className={clsx(classes.fab, classes.fabGreen)}
                     onClick={this.scrollToBottom}>
                  <DownIcon style={{fontSize: 50}}/>
                </Fab>
              }

              { this.state.scrollerDirection && this.state.scrollerDirection === "up" &&
                <Fab aria-label="scroll"
                     className={clsx(classes.fab, classes.fabGreen)}
                     onClick={this.scrollToTop}>
                  <UpIcon style={{fontSize: 50}}/>
                </Fab>
              }

              <div style={{padding: 40}}></div> {/* fakish padding for now*/}

              <div ref={(el) => { this.tailDivEl = el }} ></div>
              
            </React.Fragment>
	)
    }
}

IDashState.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles, {name: "IDashState"})(IDashState)

